import ComponentStructure from '../basic'

export default class I18nForLwCard extends ComponentStructure {
  name = 'lw-card'
  properties = []

  getHtmlElement () {
    return null
  }

  getPropertyShownElement (property: string) {
    return null
  }

  getChildComponents () {
    return this.component.components || []
  }
}
